module.exports = __webpack_public_path__ + "img/Page-1.0eace10a.svg";